import React from "react";
import { Check, X } from "lucide-react";

export const PW_MIN_LENGTH = 10;

/** Wertet die aktuellen Passwortregeln aus.
 * Muss zu ``core/security.py::validate_password_strength`` passen. */
export function evaluatePassword(pw) {
    const p = pw || "";
    return {
        length: p.length >= PW_MIN_LENGTH,
        upper: /[A-Z]/.test(p),
        lower: /[a-z]/.test(p),
        digit: /\d/.test(p),
        special: /[^A-Za-z0-9]/.test(p),
    };
}

export function isPasswordStrong(pw) {
    const r = evaluatePassword(pw);
    return r.length && r.upper && r.lower && r.digit && r.special;
}

/** Erzeugt ein zufälliges, regelkonformes Passwort (Standard 14 Zeichen). */
export function suggestPassword(length = 14) {
    const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";       // ohne I/O für Lesbarkeit
    const lower = "abcdefghjkmnpqrstuvwxyz";        // ohne i/l/o
    const digits = "23456789";                       // ohne 0/1
    const special = "!#$%&*+-?@";
    const all = upper + lower + digits + special;
    const rnd = (s) => s[Math.floor(Math.random() * s.length)];
    // Pflichtzeichen: je 1 aus jeder Klasse
    let chars = [rnd(upper), rnd(lower), rnd(digits), rnd(special)];
    while (chars.length < length) chars.push(rnd(all));
    // Shuffle (Fisher-Yates)
    for (let i = chars.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [chars[i], chars[j]] = [chars[j], chars[i]];
    }
    return chars.join("");
}

const RULES = [
    { key: "length", label: `Mindestens ${PW_MIN_LENGTH} Zeichen` },
    { key: "upper", label: "Ein Großbuchstabe (A–Z)" },
    { key: "lower", label: "Ein Kleinbuchstabe (a–z)" },
    { key: "digit", label: "Eine Ziffer (0–9)" },
    { key: "special", label: "Ein Sonderzeichen (z. B. ! # $ %)" },
];

export default function PasswordStrength({ pw, className = "" }) {
    const r = evaluatePassword(pw);
    return (
        <ul className={`mt-2 space-y-1 ${className}`} data-testid="pw-strength">
            {RULES.map(({ key, label }) => {
                const ok = r[key];
                return (
                    <li
                        key={key}
                        className={`flex items-center gap-2 text-[11px] ${ok ? "text-emerald-300" : "text-muted-foreground"}`}
                    >
                        {ok ? <Check className="h-3 w-3" /> : <X className="h-3 w-3 opacity-40" />}
                        <span>{label}</span>
                    </li>
                );
            })}
        </ul>
    );
}
